import { render, staticRenderFns } from "./AIChat_Banner_2.vue?vue&type=template&id=8195feb2&scoped=true"
import script from "./AIChat_Banner_2.vue?vue&type=script&lang=js"
export * from "./AIChat_Banner_2.vue?vue&type=script&lang=js"
import style0 from "./AIChat_Banner_2.vue?vue&type=style&index=0&id=8195feb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8195feb2",
  null
  
)

export default component.exports